module.exports = __webpack_public_path__ + "static/media/ddqx_d_right.6a4a25e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/share/ddqx_d_right.png
// module id = 380
// module chunks = 0